import apiClient from "../apiClient";

export const resendEmailVerification = async (email) => {
  try {
    // console.log("Correo reenvio", {
    //   email: email,
    // });
    const response = await apiClient.post("verify/resend-verification", {
      email: email,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
